module.exports = __webpack_public_path__ + "img/club-zh.83cab1f0.jpg";